import { useState } from "react";
import { ArrowRight, Check } from "lucide-react";
import { sendToTeam } from "../lib/formSubmit";

/**
 * Newsletter signup form used in the footer.
 * Posts to FormSubmit which forwards to team@powerbess.ai.
 */
export function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | sending | success | error
  const [errMsg, setErrMsg] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (state === "sending" || !email) return;
    setState("sending");
    setErrMsg("");
    try {
      await sendToTeam({
        _subject: `[Newsletter] New subscriber — ${email}`,
        Email: email,
        Source: "footer newsletter form",
        "Subscribed at": new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }),
        Page: typeof window !== "undefined" ? window.location.pathname : "",
      });
      setState("success");
      setEmail("");
    } catch (err) {
      setState("error");
      setErrMsg("Couldn't subscribe right now. Please try again or email team@powerbess.ai.");
    }
  };

  if (state === "success") {
    return (
      <div className="lp-ft-newsletter-success" data-testid="newsletter-success">
        <span className="lp-ft-newsletter-tick"><Check size={14} strokeWidth={3} /></span>
        Thanks — you&apos;re on the list. The next Signal lands in your inbox soon.
      </div>
    );
  }

  return (
    <form className="lp-ft-newsletter-form" onSubmit={onSubmit} data-testid="newsletter-form" noValidate>
      <input
        type="email"
        name="email"
        required
        placeholder="you@yourcompany.com"
        className="lp-ft-newsletter-input"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        disabled={state === "sending"}
        data-testid="newsletter-input"
      />
      <button
        type="submit"
        className="lp-ft-newsletter-btn"
        disabled={state === "sending" || !email}
        data-testid="newsletter-submit"
      >
        {state === "sending" ? "Subscribing…" : <>Subscribe <ArrowRight size={14}/></>}
      </button>
      {state === "error" && (
        <div className="lp-ft-newsletter-error" role="alert" data-testid="newsletter-error">
          {errMsg}
        </div>
      )}
    </form>
  );
}
